// @ts-nocheck
import { useEffect, useState } from 'react'

import api from '../api/api'
import WellMonthAgGrid from './WellMonthAgGrid'


function CreateRequestModal({ user, onClose, onCreated }) {
  const [orgs, setOrgs] = useState(() => (
    user.is_admin ? [] : [{ id: user.org, name: user.org_name }]
  ))
  const [requesters, setRequesters] = useState([])
  const [wellSearch, setWellSearch] = useState('')
  const [wellSuggestions, setWellSuggestions] = useState([])
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [duplicateWarning, setDuplicateWarning] = useState(null)
  const [allowDuplicate, setAllowDuplicate] = useState(false)
  const [locationFromGraph, setLocationFromGraph] = useState(false)

  const [form, setForm] = useState({
    deposit: '',
    bush: '',
    well: '',
    org: user.is_admin ? '' : user.org,
    requested_date: '',
    description: '',
    location: '',
    requested_by_name: '',
    title: 'Контрольный спуск фрезы',
  })

  useEffect(() => {
    if (!user.is_admin) {
      return
    }

    api.get('orgs/')
      .then((res) => setOrgs(res.data))
      .catch(err => console.error(err))
  }, [user])

  useEffect(() => {
    api.get('requesters/', {
      params: {
        location: form.location || undefined,
      },
    })
      .then((res) => setRequesters(res.data || []))
      .catch(err => console.error(err))
  }, [form.location])

  useEffect(() => {
    if (wellSearch.length < 2) {
      return
    }

    api.get('wells/', {
      params: {
        q: wellSearch,
      },
    })
      .then((res) => setWellSuggestions(res.data))
      .catch(err => console.error(err))
  }, [wellSearch])

  function changeField(name, value) {
    setDuplicateWarning(null)
    setAllowDuplicate(false)
    setForm(prev => ({
      ...prev,
      [name]: value,
      ...(name === 'location' ? { requested_by_name: '' } : {}),
    }))
  }

  async function selectWell(well) {
    setWellSearch(
      `${well.deposit_name} / куст ${well.bush_name} / скв. ${well.name}`
    )

    let graphOrg = ''
    let graphLocation = ''

    try {
      const response = await api.get('well-current-graph/', {
        params: {
          well: well.id,
        },
      })

      if (response.data?.found && response.data.graph?.org) {
        graphOrg = response.data.graph.org
        graphLocation = response.data.graph.location_code || ''

        setOrgs((currentOrgs) => {
          if (currentOrgs.some((item) => item.id === graphOrg)) {
            return currentOrgs
          }

          return [
            ...currentOrgs,
            {
              id: graphOrg,
              name: response.data.graph.org_name,
            },
          ]
        })
      }
    } catch (error) {
      console.error(error)
    }

    setForm(prev => ({
      ...prev,
      deposit: well.deposit,
      bush: well.bush,
      well: well.id,
      org: graphOrg || prev.org,
      location: graphLocation || '',
      requested_by_name: graphLocation && graphLocation !== prev.location ? '' : prev.requested_by_name,
    }))
    setLocationFromGraph(Boolean(graphLocation))

    setDuplicateWarning(null)
    setAllowDuplicate(false)
    setWellSuggestions([])
  }

  async function submitForm(event) {
    event.preventDefault()

    if (isSubmitting) {
      return
    }

    setIsSubmitting(true)

    try {
      if (!allowDuplicate) {
        const duplicateResponse = await api.get('requests/duplicate-check/', {
          params: {
            well: form.well,
            org: form.org,
            requested_date: form.requested_date,
          },
        })

        if (duplicateResponse.data?.exists) {
          setDuplicateWarning(duplicateResponse.data.matches || [])
          setAllowDuplicate(true)
          return
        }
      }

      await api.post('requests/', form)

      await onCreated()
      onClose()
    } catch (error) {
      console.error('Ошибка создания заявки:', error.response?.data || error)
      alert(JSON.stringify(error.response?.data, null, 2))
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={headerStyle}>
          <h3 style={{ margin: 0 }}>Создать заявку</h3>

          <button type="button" onClick={onClose} style={closeButtonStyle} disabled={isSubmitting}>
            ×
          </button>
        </div>

        <form onSubmit={submitForm}>
          <div style={gridStyle}>
            <div style={{ gridColumn: '1 / 3' }}>
              <div style={labelStyle}>Поиск скважины</div>

              <input
                style={inputStyle}
                value={wellSearch}
                onChange={(e) => {
                  setWellSearch(e.target.value)
                  setWellSuggestions([])
                  setDuplicateWarning(null)
                  setAllowDuplicate(false)

                  setForm(prev => ({
                    ...prev,
                    deposit: '',
                    bush: '',
                    well: '',
                    location: '',
                    requested_by_name: '',
                  }))
                  setLocationFromGraph(false)
                }}
                placeholder="Введите номер скважины"
                required
              />

              {wellSuggestions.length > 0 && (
                <div style={suggestionsStyle}>
                  {wellSuggestions.map((well) => (
                    <div
                      key={well.id}
                      onClick={() => selectWell(well)}
                      style={suggestionItemStyle}
                    >
                      {well.deposit_name} / куст {well.bush_name} / скв. {well.name}
                    </div>
                  ))}
                </div>
              )}
            </div>

            <label>
              <div style={labelStyle}>Подрядчик</div>
              <select
                style={inputStyle}
                value={form.org}
                onChange={(e) => changeField('org', e.target.value)}
                required
              >
                <option value="">Выберите</option>

                {orgs.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </label>

            <label>
              <div style={labelStyle}>Плановая дата КС</div>

              <input
                type="date"
                style={inputStyle}
                value={form.requested_date}
                onChange={(e) =>
                  changeField('requested_date', e.target.value)
                }
                required
              />
            </label>
          </div>

              <WellMonthAgGrid

                wellId={form.well}
                orgId={form.org}
                onSelectDate={(date) => changeField('requested_date', date)}
              />

          <label>
            <div style={{ ...labelStyle, margin: '0 14px 4px' }}>
              Описание
            </div>

            <textarea
              style={textareaStyle}
              value={form.description}
              onChange={(e) => changeField('description', e.target.value)}
              placeholder="Например: Срочно выполнить контрольный спуск фрезы"
            />
          </label>

          <div style={gridStyle}>
            <label>
              <div style={labelStyle}>Локация</div>
              <select
                style={inputStyle}
                value={form.location}
                onChange={(e) => changeField('location', e.target.value)}
                disabled={locationFromGraph}
                required
              >
                <option value="">Выберите</option>
                <option value="NORTH">СЕВЕР</option>
                <option value="EAST">ВОСТОК</option>
                <option value="WEST">ЗАПАД</option>
                <option value="SOUTH">ЮГ</option>
              </select>
              {locationFromGraph && (
                <div style={hintStyle}>Подставлено из графика</div>
              )}
            </label>

            <label>
              <div style={labelStyle}>Кто затребовал заявку</div>
              <select
                style={inputStyle}
                value={form.requested_by_name}
                onChange={(e) => changeField('requested_by_name', e.target.value)}
                disabled={!form.location}
                required
              >
                <option value="">Выберите ФИО</option>
                {requesters.map((item) => (
                  <option key={item.id} value={item.name}>
                    {item.name}
                  </option>
                ))}
              </select>
            </label>
          </div>

          {duplicateWarning && (
            <div style={duplicateWarningStyle}>
              <div style={duplicateTitleStyle}>Похожая активная заявка уже есть</div>
              {duplicateWarning.map((request) => (
                <div key={request.id}>
                  {request.display_number} / куст {request.bush_name} / скв. {request.well_name} / {request.status_display}
                </div>
              ))}
              <div style={duplicateHintStyle}>
                Проверьте данные. Если заявку все равно нужно создать, нажмите кнопку еще раз.
              </div>
            </div>
          )}

          <div style={footerStyle}>
            <button type="button" onClick={onClose} style={cancelButtonStyle} disabled={isSubmitting}>
              Отмена
            </button>

            <button type="submit" style={saveButtonStyle} disabled={isSubmitting}>
              {isSubmitting ? 'Создаем...' : allowDuplicate ? 'Создать все равно' : 'Создать'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}


const overlayStyle = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.35)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
}

const modalStyle = {
  width: '860px',
  background: '#fff',
  border: '1px solid #999',
  boxShadow: '0 8px 30px rgba(0,0,0,0.25)',
}

const headerStyle = {
  padding: '10px 14px',
  background: '#e9e9e9',
  borderBottom: '1px solid #c7c7c7',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}

const closeButtonStyle = {
  border: 'none',
  background: 'transparent',
  fontSize: '24px',
  cursor: 'pointer',
}

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '12px',
  padding: '14px',
}

const labelStyle = {
  fontSize: '12px',
  marginBottom: '4px',
}

const inputStyle = {
  width: '100%',
  height: '32px',
  border: '1px solid #bdbdbd',
  padding: '4px',
  boxSizing: 'border-box',
}

const hintStyle = {
  marginTop: '4px',
  color: '#667085',
  fontSize: '12px',
}

const suggestionsStyle = {
  border: '1px solid #bdbdbd',
  background: '#fff',
  marginTop: '4px',
  maxHeight: '180px',
  overflowY: 'auto',
  position: 'relative',
  zIndex: 10,
}

const suggestionItemStyle = {
  padding: '8px',
  cursor: 'pointer',
  borderBottom: '1px solid #eee',
}

const textareaStyle = {
  width: 'calc(100% - 28px)',
  height: '90px',
  margin: '0 14px',
  border: '1px solid #bdbdbd',
  padding: '6px',
  boxSizing: 'border-box',
}

const duplicateWarningStyle = {
  margin: '10px 14px 0',
  padding: '10px',
  background: '#fff8e5',
  border: '1px solid #f0c36d',
  color: '#7a4f01',
  fontSize: '12px',
  lineHeight: 1.45,
}

const duplicateTitleStyle = {
  fontWeight: 700,
  marginBottom: '4px',
}

const duplicateHintStyle = {
  marginTop: '6px',
  color: '#8a6d3b',
}

const footerStyle = {
  padding: '14px',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '10px',
}

const cancelButtonStyle = {
  height: '32px',
  padding: '0 14px',
  background: '#eee',
  border: '1px solid #aaa',
  cursor: 'pointer',
}

const saveButtonStyle = {
  height: '32px',
  padding: '0 14px',
  background: '#1976d2',
  color: '#fff',
  border: '1px solid #0d47a1',
  cursor: 'pointer',
}

export default CreateRequestModal
